<div [formGroup]="form">
<mat-select [placeholder]="placeholder"
            [formControlName]="controlName">
  <mat-select-trigger *ngIf="selectedMsisdn">
    <cc-msisdn-dropdown-item [msisdn]="selectedMsisdn"></cc-msisdn-dropdown-item>
  </mat-select-trigger>

  <mat-option *ngFor="let msisdn of msisdns"
              [value]="msisdn.id">
    <cc-msisdn-dropdown-item [msisdn]="msisdn"></cc-msisdn-dropdown-item>
  </mat-option>
</mat-select>
</div>
